module.exports = __webpack_public_path__ + "static/media/404.3b96d002.svg";